import React from 'react';
import { Button, Modal } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import modalContainer from 'packages/common/modalContainer';
import { PageLoader } from 'packages/pages/PageLoader';

type ModalProps = {
    show: boolean;
    pageName: string;
    onClose: () => void;
    onConfirm: () => void;
    isInAction: boolean;
};

const PageDeleteModal = ({ show, pageName, onClose, onConfirm, isInAction }: ModalProps) => {
    const { translate } = useTranslate();

    if (!show) {
        return null;
    }

    return (
        <Modal
            container={modalContainer}
            title={translate('editor.page.delete.modal.title', { pageName })}
            isOpen={show}
            onClose={onClose}
            actionSecondary={
                !isInAction && (
                    <Button variant="secondary" onClick={onClose}>
                        {translate('editor.page.delete.modal.cancel')}
                    </Button>
                )
            }
            actionPrimary={
                !isInAction && (
                    <Button variant="primary" onClick={onConfirm}>
                        {translate('editor.page.delete.modal.delete')}
                    </Button>
                )
            }
        >
            {isInAction && <PageLoader />}
            {!isInAction && translate('editor.page.delete.modal.content')}
        </Modal>
    );
};

export default React.memo(PageDeleteModal);
